import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Amplitude from "@Shared/utils/amplitude";
import { createHelpers } from "@joandvgv/vuex-map-fields";
import PhoneInput from "@Shared/components/inputs/phone-input";
import MaterialInput from "@Shared/components/inputs/material-input";
import DatepickerInput from "@Shared/components/inputs/datepicker-input.vue";
import { mapState } from "vuex";
const {
  mapFields
} = createHelpers({
  getterType: "getDetails",
  mutationType: "setDetails"
});
const name = "client-profile-details";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import AccountValidationMixin from "@Broker/js/mixins/validations/store-validations/account-mixin";
import { validDate, pastDate } from "@Shared/@Utils/validation-rules";
import Err from "../../../../../routes/error";
import ClientProfileDetailsLoader from "./client-profile-details-loader";
import CollapsibleCard from "@Broker/@Modules/clients/board/client-profile/components/shared/collapsible-card.vue";
import { defineComponent } from "@vue/composition-api";
import ServerSideReferrersSelect from "@Broker/@Modules/clients/referrers/components/server-side-referrers-select.vue";
export default defineComponent({
  name,
  components: {
    PhoneInput,
    ServerSideReferrersSelect,
    MaterialInput,
    ClientProfileDetailsLoader,
    DatepickerInput,
    CollapsibleCard
  },
  mixins: [validationMixin, AccountValidationMixin],
  props: {
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    adding: Boolean,
    boardId: {
      type: [String, Number],
      required: true
    },
    profile: {
      type: Object,
      required: true
    },
    referrers: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    collapse: {
      type: Boolean,
      default: true
    }
  },
  data() {
    var _this$profile;
    return {
      timer: 0,
      emailWarning: true,
      currentEmail: (_this$profile = this.profile) == null ? void 0 : _this$profile.email,
      mask: {
        alias: "currency",
        rightAlign: false,
        prefix: "$",
        showMaskOnHover: false,
        allowMinus: false,
        allowPlus: false,
        autoUnmask: true,
        repeat: 10
      }
    };
  },
  validations: {
    givenName: {
      required
    },
    email: {
      email
    },
    dateOfBirth: {
      validDate,
      pastDate
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapFields("BoardStore", {
    givenName() {
      return this.bindProfile();
    },
    familyName() {
      return this.bindProfile();
    },
    email() {
      return this.bindProfile();
    },
    phoneNumber() {
      return this.bindProfile();
    },
    dateOfBirth() {
      return this.bindProfile();
    },
    value() {
      return this.bindProfile();
    },
    referrerId() {
      return this.bindProfile();
    },
    referrer() {
      return this.bindProfile();
    }
  })), mapState("AccountStore", ["apiBasePath", "userDetails", "token"])), {}, {
    referrerSelected() {
      var _this$profile2, _this$profile2$referr, _this$profile3, _this$profile4;
      if ((_this$profile2 = this.profile) != null && (_this$profile2$referr = _this$profile2.referrer) != null && _this$profile2$referr.id) return (_this$profile3 = this.profile) == null ? void 0 : _this$profile3.referrer;
      return _objectSpread(_objectSpread({}, (_this$profile4 = this.profile) == null ? void 0 : _this$profile4.referrer), {}, {
        id: this.referrerId
      });
    },
    emptyReferrer() {
      return !this.referrerId || this.referrerId === "null";
    }
  }),
  watch: {
    email(val) {
      if (this.currentEmail) return;
      this.currentEmail = val;
    },
    referrerId(value, oldValue) {
      if ((oldValue || oldValue === null) && this.referrers.length) {
        const {
          id: latestReferrer
        } = this.referrers[this.referrers.length - 1];
        if (latestReferrer === value) this.saveOnType();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      const eye = this.$refs.eye;
      $(eye).tooltip();
    });
  },
  methods: {
    bindProfile() {
      return this.clientProfileId;
    },
    formatTimeAgo(value) {
      return this.$options.filters.formatTimeAgo(value);
    },
    async saveOnType() {
      try {
        const isValid = !this.$v.$invalid;
        if (!isValid) return;
        this.$emit("save");
      } catch (error) {
        const {
          message
        } = error.responseJSON || {
          message: "Error saving your details."
        };
        Err.handle(message, error);
        Amplitude.logHandledError(error, {}, message);
      }
    },
    updateReferrer({
      referrer,
      type
    }) {
      switch (type) {
        case "unselect":
          this.referrerId = null;
          this.referrer = {
            familyName: "",
            givenName: ""
          };
          break;
        case "select":
          this.referrerId = referrer.id;
          this.referrer = {
            familyName: referrer.familyName,
            givenName: referrer.givenName
          };
          break;
      }
      this.saveOnType();
    },
    openReferrersModal(referrerId = null, referrerDetails, type) {
      this.$emit("handle-referrer", referrerId, referrerDetails, type);
    },
    formatReferrerSelection(data) {
      return data.givenName && data.familyName ? `${data.givenName} ${data.familyName}` : data.text;
    },
    handleReferrer({
      referrerId,
      referrerData
    }) {
      this.$emit("handle-referrer", referrerId, referrerData, "referrer");
    }
  }
});